import { jsx as e, jsxs as t, Fragment as n } from "react/jsx-runtime";

import { forwardRef as o, useState as r } from "react";

import { useFloating as i, offset as l, flip as s, shift as a, autoUpdate as m, useClick as c, useRole as d, useDismiss as p, useInteractions as u, useMergeRefs as f, FloatingFocusManager as h } from "@floating-ui/react";

import b from "../../../../utils/classNames/index.js";

import g from "@ui-components-3/icons/lib/regular/Gear";

import x from "@ui-components-3/icons/lib/regular/Eye";

import y from "@ui-components-3/icons/lib/regular/EyeSlash";

import w from "../../hooks/useTableContext/index.js";

import { COLOR_VARIANT_TEXT_CLASSES as N } from "../../constants/index.js";

const v = ({column: n, colorVariant: o}) => {
    const r = n.getCanHide(), i = n.getIsVisible(), l = n.columnDef.header, s = l ? "string" == typeof l ? l : l({}) : "", a = i ? x : y;
    return r ? t("div", {
        className: "flex justify-between",
        children: [ e("p", {
            className: "typography-body",
            children: s
        }), e("button", {
            type: "button",
            disabled: !r,
            className: b("btn-unsized btn-neutral-borderless disabled:bg-transparent", N[o], !i && "!text-neutral-700"),
            onClick: n.getToggleVisibilityHandler(),
            "aria-label": `${i ? "Hide" : "Show"} ${s} Column`,
            children: e(a, {
                "aria-hidden": "true",
                className: ""
            })
        }) ]
    }) : null;
}, C = () => {
    const {model: o, colorVariant: r} = w(), i = o?.getAllColumns();
    return e("div", {
        className: "gap-xs flex flex-col",
        children: i ? t(n, {
            children: [ e("p", {
                className: "typography-body-l font-medium",
                children: "Column Visibility"
            }), i.map((t => e(v, {
                column: t,
                colorVariant: r
            }, `column:visibility:${t.id}`))) ]
        }) : null
    });
}, V = o((({children: o}, x) => {
    const [y, v] = r(!1), V = w();
    if ("production" !== process.env.NODE_ENV) {
        if (!V) 
        // TODO: should it be passable as a "prefix" prop? not ideal, but may be the only way to access context w/out some children mutation (boo).
        throw new Error("Settings Component is only supported as a Table component child.");
        if (!V.model) throw new Error('Settings Component is only supported within tables using "useTable".');
    }
    const {colorVariant: E} = V, {refs: S, context: j, strategy: T, x: F, y: k, floatingStyles: z} = i({
        open: y,
        onOpenChange: v,
        placement: "top-end",
        middleware: [ l({
            mainAxis: 4,
            alignmentAxis: 0
        }), s(), a() ],
        transform: !1,
        whileElementsMounted: m
    }), A = c(j, {
        event: "mousedown"
    }), H = d(j, {
        role: "menu"
    }), O = p(j), {getReferenceProps: $, getFloatingProps: D} = u([ A, H, O ]), I = f([ S.setReference, x ]), P = y && e(h, {
        context: j,
        modal: !1,
        initialFocus: 0,
        returnFocus: !0,
        children: e("div", {
            ref: S.setFloating,
            className: "pt-s w-full max-w-[335px] overflow-hidden rounded-xl border bg-white shadow-sm",
            style: {
                ...z,
                position: T,
                top: k ?? 0,
                left: F ?? 0,
                zIndex: 2
            },
            ...D(),
            children: t("div", {
                className: "gap-s p-s flex h-fit max-h-[498px] flex-col overflow-y-auto pt-0",
                children: [ e(C, {}), !!o && e("hr", {}), o ]
            })
        })
    });
    return t(n, {
        children: [ e("button", {
            type: "button",
            className: b("btn-unsized gap-xs btn-neutral-borderless", N[E]),
            ref: I,
            ...$(),
            "aria-label": "Open Table Settings",
            children: e(g, {
                "aria-hidden": "true",
                className: "m-xxs h-5 w-5 shrink-0"
            })
        }), P ]
    });
}));

export { V as default };
//# sourceMappingURL=index.js.map
